import React from 'react'
import { Container } from '@material-ui/core';

const MobileRestricted = () => {
    return (        
      <div className="mobile-restricted-overlay">
        <Container>
          <p><strong>
              Thank you for visiting Matilda MyDigital
            </strong>
            To have the best experience viewing resources here we recommend you visit us from a desktop computer.
          </p>
        </Container>
      </div>

    )
}

export default MobileRestricted
